<template>
    <div class="tab-content">
        <van-list
                v-if="(list && list.length) || loading"
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">

            <ai-match-item v-for="item in list" :type="'tab'" :item="item"></ai-match-item>
        </van-list>
        <no-data v-else></no-data>
    </div>
</template>

<script>
  import AiMatchItem from '@/components/aiMatch/aiMatchItem'
  import {getAiTalents} from '@/api/positions'
  import {getAiMatchScore , getAiTalentTags} from '@/api/aiMatch'
  import NoData from "@/components/noData";
  export default {
    components: { AiMatchItem , NoData},
    props: {
      type:{
        type:Number,
        default:1
      }
    },
    data() {
      return {
        list: [],
        loading: false,
        finished: false,
        pageSize: 10,
        pageNo: 1,
      }
    },
    methods: {
      onLoad() {
        this.loading = true;
        let params = [],
          getList = '';
        if(this.type == 1){
          params = {pageNo:this.pageNo, pageSize: this.pageSize, queryType: 1, positionId: this.$route.params.positionId, ...this.$route.query};
          getList = getAiTalents;
        }
        getList(params).then(res=>{
          if(res.data&&res.data.talentList){
            let ids = [];
            res.data.talentList.forEach(item=>{
              item.matchScore = 0;
              item.matchCounts = 0;
              item.unMatchCounts = 0;
              item.avatarUrl = item.avatar && item.avatar.remoteUrl ? item.avatar.remoteUrl : null;
              item.tags = {};
              ids.push(item.talentId);
            })

            this.list = this.list.concat(res.data.talentList||[]);
            this.pageNo++;
            if(res.data.talentList.length<this.pageSize)
              this.finished = true;

            if(ids.length){
              this.getMatchScore(ids);
              this.getTags(ids)
            }
          }
        }).catch(err=>{}).finally(()=>{this.loading = false;})
      },
      getMatchScore(ids){
        let query = {ids: ids.join(',')};
        if(this.type == 1) {
          query.type = 3;
          query.id = this.$route.params.positionId;
        }
        getAiMatchScore({...query}).then(res=>{
          if(res.data){
            for(let id in res.data){
              let aiArr = [];
              let item = res.data[id];
              item.mustmust.forEach(e=>{
                if(e.cityScore || e.functionScore || e.ageScore || e.workYearsScore || e.cityScore == false || e.functionScore == false || e.ageScore == false || e.workYearsScore == false){
                  aiArr.push(e);
                }
              })
              item.precedence.forEach(e=>{
                if(e.degreeScore >= 0 || e.salaryScore >= 0 || e.skillScore >= 0 || e.fieldScore >= 0 || e.companyFactionScore >= 0){
                  aiArr.push(e);
                }
              })
              aiArr.forEach(e=>{
                if(e.cityScore || e.functionScore || e.ageScore || e.workYearsScore || e.degreeScore >= 0.544 || e.salaryScore >= 0.544 || e.skillScore >= 0.544 || e.fieldScore >= 0.544 || e.companyFactionScore >= 0.544){
                  item.matchCounts = (item.matchCounts||0) + 1;
                }else if(!e.sourceSalary || (e.sourceSalary && e.sourceSalaryName && e.salaryScore < 0.544)){
                  item.unMatchCounts = (item.unMatchCounts||0) + 1;
                }
              })
            }

            this.list.forEach(item=>{
              if(res.data[item.talentId]){
                item.matchScore = res.data[item.talentId].matchScore;
                item.matchCounts = res.data[item.talentId].matchCounts;
                item.unMatchCounts = res.data[item.talentId].unMatchCounts;
              }
            })
          }
        }).catch(err=>{})
      },
      getTags(ids){
        getAiTalentTags({talentIds: ids.join(',')}).then(res=>{
          if(res.data){
            this.list.forEach(item=>{
              if(res.data[item.talentId]){
                item.tags = res.data[item.talentId];
              }
            })
            console.log(this.list,'<<<<<<<<<<list')
          }
        }).catch(err=>{})
      }
    },
    watch: {
      $route(n,o){
        this.list = [];
        this.pageNo = 1;
        this.finished = false;
        this.onLoad();
      }
    },
    created() {
      this.onLoad();
    }
  };
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.tab-content{
    padding: 0!important;
    background-color: #f5f5f5;
}
</style>
